import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useReactRouterBreadcrumbs from 'use-react-router-breadcrumbs';
import classNames from 'classnames';
import styles from './BreadCrumbs.module.css';
import breadcrumbArrow from '../../../assets/images/breadcrumbArrow.png';

const routes = [
  { path: '/', breadcrumb: 'Dashboard' },
  { path: '/dashboard', breadcrumb: 'Dashboard' },
  { path: '/private', breadcrumb: 'Register Private Client' },
  { path: '/legal', breadcrumb: 'Register Corporate Client' },
  { path: '/search', breadcrumb: 'Client Search' },
  { path: '/customer', breadcrumb: 'Client Dashboard' },
  { path: '/customer/representative', breadcrumb: 'Adding representative' },
  { path: '/customer/history', breadcrumb: 'Questionnaire history' },
  { path: '/customer/questionnaire', breadcrumb: 'Questionnaire info' },
];

function BreadCrumbs() {
  const { t } = useTranslation();
  const breadcrumbs = useReactRouterBreadcrumbs(routes);

  return (
    <div className={styles.navigation}>
      {breadcrumbs.splice(0, breadcrumbs.length - 1).map(({
        match,
        breadcrumb
      }, index) => (
        <span key={match.pathname} className={classNames(
          styles.link,
          index !== breadcrumbs.length - 1 ? styles.active : '',
        )}>
          <NavLink to={match.pathname}>{breadcrumb}</NavLink>
          {index === breadcrumbs.length - 1 && <span className={styles.separator}>/</span>}
        </span>
      ))}
      <img
        src={breadcrumbArrow}
        alt={t('breadCrumb.backArrow')}
        className={styles.arrowImg}
        role='presentation'
      />
    </div>
  );
}

export default BreadCrumbs;
